export enum DiscordButtonStyle {
  Primary = "Primary",
  Secondary = "Secondary",
  Success = "Success",
  Danger = "Danger",
  Link = "Link",
}
